<main>
  <div class="selfie">
    <p>Para que possamos realizar a chamada automática solicitamos que o aluno envie três fotos. Essas imagens serão
      utilizadas exclusivamente para a identificação automática do aluno durante a chamada e não serão compartilhadas
      ou
      usadas para outros fins.</p>

    <div class="cards">
      <div class="card-content">
        <div class="foto-example">
          <div class="img">
            <img src="../../../../../../../assets/images/Frente.png" alt="">
          </div>
          <div class="infos">
            <span>Foto frontal</span>
            <p>Uma foto de frente, onde o rosto do aluno esteja bem visível e iluminado.</p>
          </div>
        </div>

        @if(aluno?.foto_frontal || fotoFrontal) {
        <div class="foto-capturada">
          @if(fotoFrontalCapturadaUrl === undefined) {
            <div class="loader">
              <app-loader-teste></app-loader-teste>
            </div>
          } @else {
            <div class="info">
              <img [src]="fotoFrontalCapturadaUrl" alt="Pré-visualização da Foto" class="photo-preview" />
              <span>frente.JPEG</span>
            </div>

            <div class="action">
              <span class="material-symbols-outlined" (click)="clearPhoto('frontal')">
                delete
              </span>
            </div>
          }
        </div>
        } @else {
        <div class="btn-selfies">
          <tgt-button type="button" (click)="openFileFotoFrontal()" [color]="'primary'" [size]="'middle'"
            [border]="false" [fieldButton]="'outline'" [icon]="'add_a_photo'" iconPosition="right">Capturar</tgt-button>
          <input id="fileInputFotoFrontal" type="file" accept="image/*" capture="environment"
            (change)="onFileSelectedFrontal($event)" hidden>
          <tgt-button [size]="'middle'" type="button" (click)="openFileFotoFrontal()" [color]="'primary'"
            [border]="false" [fieldButton]="'outline'" [icon]="'upgrade'" iconPosition="right">Carregar</tgt-button>
        </div>
        }

      </div>
      <div class="card-content">
        <div class="foto-example">
          <div class="img">
            <img src="../../../../../../../assets/images/Lado 2.png" alt="">
          </div>
          <div class="infos">
            <span>Foto do lado direito</span>
            <p>Uma foto do lado direito do rosto, para auxiliar no reconhecimento de diferentes ângulos.</p>
          </div>
        </div>

        @if(aluno?.foto_direito || fotoDireito) {
        <div class="foto-capturada">
          @if(fotoDireitoCapturadaUrl === undefined) {
            <div class="loader">
              <app-loader-teste></app-loader-teste>
            </div>
          } @else {
            <div class="info">
              <img [src]="fotoDireitoCapturadaUrl" alt="Pré-visualização da Foto" class="photo-preview" />
              <span>direita.JPEG</span>
            </div>

            <div class="action">
              <span class="material-symbols-outlined" (click)="clearPhoto('direito')">
                delete
              </span>
            </div>
          }
        </div>
        } @else {
        <div class="btn-selfies">
          <tgt-button type="button" (click)="openFileFotoDireito()" [color]="'primary'" [size]="'middle'"
            [border]="false" [fieldButton]="'outline'" [icon]="'add_a_photo'" iconPosition="right">Capturar</tgt-button>
          <input id="fileInputFotoDireito" type="file" accept="image/*" capture="environment"
            (change)="onFileSelectedDireito($event)" hidden>
          <tgt-button [size]="'middle'" type="button" (click)="openFileFotoDireito()" [color]="'primary'"
            [border]="false" [fieldButton]="'outline'" [icon]="'upgrade'" iconPosition="right">Carregar</tgt-button>
        </div>
        }
      </div>

      <div class="card-content">
        <div class="foto-example">
          <div class="img">
            <img src="../../../../../../../assets/images/Lado 1.png" alt="">
          </div>
          <div class="infos">
            <span>Foto do lado esquerdo</span>
            <p>Uma foto do lado esquerdo do rosto, para auxiliar no reconhecimento de diferentes ângulos.</p>
          </div>
        </div>
        @if(aluno?.foto_esquerdo || fotoEsquerdo) {
        <div class="foto-capturada">
          @if(fotoEsquerdoCapturadaUrl === undefined) {
            <div class="loader">
              <app-loader-teste></app-loader-teste>
            </div>
          } @else {
            <div class="info">
              <img [src]="fotoEsquerdoCapturadaUrl" alt="Pré-visualização da Foto" class="photo-preview" />
              <span>esquerda.JPEG</span>
            </div>

            <div class="action">
              <span class="material-symbols-outlined" (click)="clearPhoto('esquerdo')">
                delete
              </span>
            </div>
          }
        </div>
        } @else {
        <div class="btn-selfies">
          <tgt-button type="button" (click)="openFileFotoEsquerdo()" [color]="'primary'" [size]="'middle'"
            [border]="false" [fieldButton]="'outline'" [icon]="'add_a_photo'" iconPosition="right">Capturar</tgt-button>
          <input id="fileInputFotoEsquerdo" type="file" accept="image/*" capture="environment"
            (change)="onFileSelectedEsquerdo($event)" hidden>
          <tgt-button [size]="'middle'" type="button" (click)="openFileFotoEsquerdo()" [color]="'primary'"
            [border]="false" [fieldButton]="'outline'" [icon]="'upgrade'" iconPosition="right">Carregar</tgt-button>
        </div>
        }

        @if(fotoEsquerdo) {

        }

      </div>



    </div>
    <div class="card-footer">
      <span>Importante!</span>
      <li>A imagem do rosto do aluno deve ser nítida;</li>
      <li>Não utilize fotos com óculos escuros ou chapéus.</li>
    </div>
  </div>
</main>
